module.exports = __webpack_public_path__ + "static/media/faq_destination_tag.8485105b.jpg";